export const ROW_HIGHLIGHTED_CLASS = 'row-highlighted';
export const ROW_EDITING_CLASS = 'row-editing';
export const ROW_CONFIRMED_CLASS = 'row-confirmed';

export const SCROLL_SETTINGS = {
  x: 'max-content'
};

export const DEFAULT_VIRTUAL_SCROLL_Y = 600;

/**
 * Fallback pixels reserved above the virtual body while the table header is not
 * yet measurable. Once rendered, the real header offset is used instead so the
 * body (and its horizontal scrollbar at the bottom) stays within the visible
 * region even when header cells wrap.
 */
export const VIRTUAL_HEADER_ALLOWANCE = 55;

/**
 * Floor for dynamically measured `scroll.y` in virtual mode. Prevents the
 * body collapsing to an unusable height on very short containers.
 */
export const MIN_VIRTUAL_SCROLL_Y = 200;

export const EXPANDABLE_CONFIG = { indentSize: 20 };

export const DRAG_ACTIVATION_DISTANCE = 8;

/**
 * Fallback widths injected into `rowSelection.columnWidth` when `virtual` is
 * enabled. AntD's virtual body grid sizes cells from each column's `width`
 * (`Math.max(width || 0, minWidth || 0)`) and ignores the colgroup-based CSS
 * width that drives the non-virtual default. Without these, the selection
 * column renders at 0px and overlaps the next column, clipping the checkboxes.
 * Values mirror the non-virtual visuals: `controlHeight` (32), plus
 * `paddingXS * 2` (16) for the bordered variant.
 */
export const VIRTUAL_SELECTION_COLUMN_WIDTH = 32;
export const VIRTUAL_SELECTION_COLUMN_WIDTH_BORDERED = 48;

/**
 * Width assumed for a virtual-mode column that declares no numeric `width`
 * when deriving the table's horizontal scroll width. Columns without an
 * explicit width are rare in this codebase; this keeps the derived total from
 * undercounting them so the table doesn't collapse such a column to ~0px.
 */
export const FALLBACK_VIRTUAL_COLUMN_WIDTH = 150;

export const DEFAULT_INPUT_SEARCH_DEBOUNCE_MS = 1000;
